import {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import { getCantieri, createCantiere, deleteCantiere, updateStatoCantiere } from '../services/cantieriService';
import '../styles/cantieri.css'

function Cantieri() {
    const [cantieri, setCantieri] = useState([]);
    const [nome, setNome] = useState('');
    const [stato, setStato] = useState('valutazione');
    const [tab, setTab] = useState('attivo');
    const navigate = useNavigate();
    const fetchCantieri = async (statoSelezionato) => {
        const { data } = await getCantieri(statoSelezionato);
        setCantieri(data);
    };

    const addCantiere = async (e) => {
        e.preventDefault();
        await createCantiere(nome, stato);
        setNome('');
        fetchCantieri(tab);

    };

    const deleteCantiereHandler = async (id) => {
        const conferma = window.confirm('Sei sicuro di voler eliminare questo cantiere?');
        if (!conferma) return;
        await deleteCantiere(id);
        fetchCantieri(tab);
    };

    const attivaCantiereHandler = async (id) => {
        const conferma = window.confirm('Sei sicuro di voler attivare questo cantiere?');
        if (!conferma) return;
        try {
            await updateStatoCantiere(id, 'attivo');
            fetchCantieri(tab);
        } catch (error) {
            console.error('Errore attivazione cantiere:', error);
            window.alert('Errore durante l\'attivazione del cantiere');
        }
    };

    const selezionaCantiere = (id, nome) => {
        localStorage.setItem('idCantiere', id);
        localStorage.setItem('nomeCantiere', nome);
        navigate(`/dashboard/${id}`);
    };

    useEffect(() => {
        fetchCantieri(tab);
    }, [tab]);

    return (
        <div className="container py-4">
            <h2 className="mb-4">Gestione Cantieri</h2>

            <form onSubmit={addCantiere} className="mb-4">
                <div className="row g-2 align-items-center">
                    <div className="col-sm-5">
                        <input
                            type="text"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            className="form-control"
                            placeholder="Nome cantiere"
                            required
                        />
                    </div>
                    <div className="col-sm-3">
                        <select
                            className="form-select"
                            value={stato}
                            onChange={(e) => setStato(e.target.value)}
                        >
                            <option value="attivo">Attivo</option>
                            <option value="valutazione">In valutazione</option>
                        </select>
                    </div>
                    <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                            Aggiungi Cantiere
                        </button>
                    </div>
                </div>
            </form>

            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${tab === 'attivo' ? 'active' : ''}`}
                        onClick={() => setTab('attivo')}
                    >
                        Cantieri Attivi
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${tab === 'valutazione' ? 'active' : ''}`}
                        onClick={() => setTab('valutazione')}
                    >
                        Cantieri in valutazione
                    </button>
                </li>
            </ul>

            {cantieri.length === 0 ? (
                <div className="text-center text-muted my-4 empty__message">
                    Ancora nessun catiere presente.<br/>
                    Aggiungi un cantiere!
                </div>
            ) : (
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {cantieri.map((c) => (
                        <div className="col" key={c.id}>
                            <div className="card shadow-sm h-100 position-relative">
                                <span
                                    className={`badge position-absolute top-0 end-0 m-3 ${c.stato === 'attivo' ? 'activeBadge' : 'evaluationBadge'}`}
                                >
                                    {c.stato === 'attivo' ? 'Attivo' : 'In Valutazione'}
                                </span>
                                <div className="card-body">
                                    <h5
                                        className="card-title text-primary"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => selezionaCantiere(c.id, c.nome)}
                                    >
                                        {c.nome}
                                    </h5>
                                    <p className="card-text text-muted">
                                        Creato il {new Date(c.created_at).toLocaleDateString()}
                                    </p>
                                    <div className="cantieriCard--actions">
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => deleteCantiereHandler(c.id)}
                                        >
                                            Elimina
                                        </button>
                                        {c.stato === 'valutazione' && (
                                            <button
                                                className="btn btn-outline-success btn-sm"
                                                onClick={() => attivaCantiereHandler(c.id)}
                                            >
                                                Attiva
                                            </button>
                                        )}
                                        <button
                                            className="goldBtn__empty btn-sm"
                                            onClick={() => selezionaCantiere(c.id, c.nome)}
                                        >
                                            Dettagli
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default Cantieri;
